import { AssigneeInput } from '@components/AssigneeInput/AssigneeInput';
import { addKnownUser } from '@store/redux/features/inventory/knownData';
import { RootState, useAppDispatch } from '@store/redux/store';
import { pick } from '@utils/pick';
import { useSelector } from 'react-redux';
import { memo } from 'react';
import { AssigneeWrapper, BigInputDiv, InputList } from '../styles';
import { PropsInputSingle, FlattenSingle } from './types';
import { onChangeSingle } from './utils';

type AssigneeInputSingleProps = PropsInputSingle & FlattenSingle<'userId'>;

function AssigneeSingle(props: AssigneeInputSingleProps) {
  const { index, userId, setFormV, onlyGroupEdits } = props;

  const userIdName = `equipments.${index}.userId` as const;
  const knownUser = useSelector(
    (state: RootState) => state.knownData.knownUsers[userId ?? ''] || null,
  );
  const dispatch = useAppDispatch();

  return (
    <InputList>
      <BigInputDiv>
        <AssigneeWrapper>
          <AssigneeInput
            borderColor="#d8dae5"
            width={338}
            handleUserChange={user => {
              if (user === null || user === undefined) {
                onChangeSingle(userIdName, null, setFormV);
                return;
              }
              dispatch(addKnownUser(pick(user, ['id', 'name'])));
              onChangeSingle(userIdName, user.id, setFormV);
            }}
            value={knownUser}
            isDisabled={onlyGroupEdits}
          />
        </AssigneeWrapper>
      </BigInputDiv>
    </InputList>
  );
}
export default memo(AssigneeSingle);
